var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { ActivityDayContainer } from '../ActivityDayContainer';
var ScDayContainer = styled(ActivityDayContainer).withConfig({ displayName: "ScDayContainer", componentId: "sc-1gkfkdt" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var $isActive = _a.$isActive;
    return $isActive
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          background: #87c9f1;\n        "], ["\n          background: #87c9f1;\n        "]))) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          background: #e3f2fc;\n        "], ["\n          background: #e3f2fc;\n        "])));
});
var EducationalDay = function (_a) {
    var timeSpent = _a.timeSpent;
    if (!timeSpent || timeSpent === 0) {
        return _jsx(ScDayContainer, { "$isActive": false }, void 0);
    }
    return (_jsx(ScDayContainer, __assign({ "$isActive": true }, { children: simplifyTime(timeSpent) }), void 0));
};
var simplifyTime = function (time, max) {
    if (max === void 0) { max = 99; }
    return (time >= max ? '99+' : time);
};
export { EducationalDay };
var templateObject_1, templateObject_2, templateObject_3;
